import { render, staticRenderFns } from "./BattleUnregister.vue?vue&type=template&id=3a4d9b3a&scoped=true"
import script from "./BattleUnregister.vue?vue&type=script&lang=js"
export * from "./BattleUnregister.vue?vue&type=script&lang=js"
import style0 from "./BattleUnregister.vue?vue&type=style&index=0&id=3a4d9b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4d9b3a",
  null
  
)

export default component.exports